<template>
  <span class="NoTips">{{ tips }}</span>
</template>
<script>
export default {
  data() {
    return {
      tips: '编码规范：请用拼音或相应英文设置编码，以"_"或"-"进行连接'
    };
  }
};
</script>
<style lang="less" scoped>
.NoTips {
  font-size: 12px;
  color: #c0c4ce;
}
</style>